export const AREA_PANEL_PROPS = {
  hotCity: Array, // 热区数据 [{label: string, value: string}]
  showHotCity: {
    type: Boolean,
    default: true
  },
  selectFullLevel: { //  // address 地址 region 区域 区域 可支持选择到任一级，每选一级都需要回填下拉框，选中任一级之后点击空白区域即可收起下拉面板
    type: Boolean,
    default: false
  },
  level: { // 默认可支持展示到的层级
    type: Number,
    default: 5
  },
  limitRegion: {
    type: Array,
    default: () => (['XZ1-07', 'XZ1-20', 'XZ1-28']) // "台湾" "香港" "澳门"
  },
  confirmNextLevel: {
    type: Boolean,
    default: true
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-area/props/area-panel.js